


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import imageUploader from "@/components/imageUploader.vue";
@Component({
  name: "avatarUploader",
  components: {
    imageUploader,
  },
})
export default class extends Vue {
  @Prop() oriImage!: string;
  @Prop() oriImageUrl!: string;
  dialogVisible: boolean = false;
  previewImage: string = "";
  previewImageUrl: string = "";
  showDialog() {
    this.dialogVisible = true;
    this.previewImage = this.oriImage;
    this.previewImageUrl = this.oriImageUrl;
  }
  closeDialog(type: string) {
    if (type === "confirm") {
      this.$emit("update:oriImage", this.previewImage);
      this.$emit("update:oriImageUrl", this.previewImageUrl);
    }
    this.dialogVisible = false;
  }
}
